import iconColab from 'assets/images/ic_colab.png';
import iconEco from 'assets/images/ic_eco.png';
import iconSave from 'assets/images/ic_save.png';

export const features = [
  {
    icon: iconColab,
    title: 'Collaboration',
    shortDesc: 'Help other businesses whilst helping yourself!',
    fullDesc:
        'Equipment imbalances are more common now than ever, thanks to industry disruptors such as Covid-19 and the associated supply & demand challenges. Stacking your empty import containers will authorise an exporter to collect the empty directly from your yard when you have finished with it, so it can be re-loaded for export.',
  },
  {
    icon: iconEco,
    title: 'Environmental Savings',
    shortDesc: 'GHG emission reductions and reduced congestion!',
    fullDesc:
        'Every time a stacked container is re-used through The VirtualStack® one entire transport leg is removed from a supply chain. Because containers are prioritised by proximity, the distance travelled for the empty leg will often also be reduced. Fewer trips means less heavy goods vehicle trips, which means significant CO² emission reductions and less road congestion.',
  },
  {
    icon: iconSave,
    title: 'Financial Savings',
    shortDesc: 'Entire transport legs made redundant!',
    fullDesc:
        'Every stacked import empty re-used by an exporter removes an empty de-hire transport leg. Two-way cart turns into One-way cart, reducing traditional trucking trip costs significantly. Empty yard booking fees are also avoided.',
  },
];

export const faqs = [
  {
    question: 'Is there any cost or obligation if I request a container?',
    answer: 'Answer to this question... Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.',
    isOpen: true,
  },
  {
    question: 'What do I do if I receive a container that is damaged?',
    answer: 'Answer to this question... Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.',
    isOpen: false
  },
  {
    question: 'What types of containers can I request?',
    answer: 'Answer to this question... Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.',
    isOpen: false
  },
  {
    question: 'How is The VirtualStack® any different from a hire depot?',
    answer: 'Answer to this question... Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.',
    isOpen: false
  },
  {
    question: 'What protections are in place so I don\'t incure import detention?',
    answer: 'Answer to this question... Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.',
    isOpen: false
  },
];
